// import { useState } from "react";
// import { useParams } from "react-router-dom";
// import { FaLeaf, FaUser, FaUsers } from "react-icons/fa";

// import { Reveal, SectionHeading, SERIF } from "./ui";
// import { getInitials } from "./SectorsData";

// /*
//  * SectorHOD — slug-driven council secretariat section.
//  *
//  * SectorPage passes the current `councilSlug`; this file then selects the
//  * matching HoD automatically. The card intentionally uses the same visual
//  * language as CouncilLeadership's Option A cards.
//  */

// export const SECTOR_HOD = {
//   /* Agriculture & Food Processing */
//   "agri-industries-farming-practices": {
//     hod: { name: "Tanuja Adhikari" },
//     clusterHead: { name: "D S Rajora" },
//   },
//   "food-processing-value-addition": {
//     hod: { name: "Tanuja Adhikari" },
//     clusterHead: { name: "D S Rajora" },
//   },

//   /* Green Mobility and Automotive & Auto Components */
//   "auto-auto-ancillaries": {
//     hod: { name: "Sumita Sharma" },
//     clusterHead: { name: "D S Rajora" },
//   },
//   "green-mobility": {
//     hod: { name: "Sumita Sharma" },
//     clusterHead: { name: "D S Rajora" },
//   },

//   /* MSME */
//   "msme-development-council": {
//     hod: { name: "Deepti Pant" },
//     clusterHead: { name: "Deepti Pant" },
//   },

//   /* Electronic Device & Semiconductor Manufacturing */
//   "electronics-components": {
//     hod: { name: "Varun Aggarwal" },
//     clusterHead: { name: "Varun Aggarwal" },
//   },

//   /* Pharma, Med-tech & Healthcare */
//   pharmaceuticals: {
//     hod: { name: "Tanuja Adhikari" },
//     clusterHead: { name: "D S Rajora" },
//   },
//   "med-tech-devices": {
//     hod: { name: "Tanuja Adhikari" },
//     clusterHead: { name: "D S Rajora" },
//   },
//   "healthcare-wellness": {
//     hod: { name: "Tanuja Adhikari" },
//     clusterHead: { name: "D S Rajora" },
//   },

//   /* Power & Energy */
//   "hydropower-psp": {
//     hod: { name: "Kavita Sharma" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },
//   "power-generation": {
//     hod: { name: "Kavita Sharma" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },
//   "power-distribution": {
//     hod: { name: "Kavita Sharma" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },
//   "power-transmission": {
//     hod: { name: "Kavita Sharma" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },
//   "renewable-energy": {
//     hod: { name: "Kavita Sharma" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },

//   /* IT / ITeS, Digital Tech & Fintech */
//   "animation-visual-effects-gaming-comics-avgc": {
//     hod: { name: "Varun Aggarwal" },
//     clusterHead: { name: "Varun Aggarwal" },
//   },
//   "cyber-security-cyber-law": {
//     hod: { name: "Varun Aggarwal" },
//     clusterHead: { name: "Varun Aggarwal" },
//   },
//   "data-centre": {
//     hod: { name: "Varun Aggarwal" },
//     clusterHead: { name: "Varun Aggarwal" },
//   },
//   "digital-communication": {
//     hod: { name: "Varun Aggarwal" },
//     clusterHead: { name: "Varun Aggarwal" },
//   },
//   "it-ites-digital-commerce": {
//     hod: { name: "Varun Aggarwal" },
//     clusterHead: { name: "Varun Aggarwal" },
//   },
//   fintech: {
//     hod: { name: "Varun Aggarwal" },
//     clusterHead: { name: "Varun Aggarwal" },
//   },

//   /* Banking, Financial Services & Insurance */
//   banking: {
//     hod: { name: "Ankit Raghav" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "capital-markets": {
//     hod: { name: "Ankit Krishna" },
//     clusterHead: { name: "D S Rajora" },
//   },
//   "commodity-markets-investments": {
//     hod: { name: "Ankit Krishna" },
//     clusterHead: { name: "D S Rajora" },
//   },
//   "corporate-bond-market": {
//     hod: { name: "Ankit Raghav" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   insurance: {
//     hod: { name: "Ankit Raghav" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "nbfcs-green-financing": {
//     hod: { name: "Ankit Raghav" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "stressed-assets": {
//     hod: { name: "Ankit Raghav" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   cfos: {
//     hod: { name: "Avinash Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },

//   /* Education & Skilling */
//   "national-council-on-education": {
//     hod: { name: "Swati Sharma" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },

//   /* Taxation */
//   "direct-taxes": {
//     hod: { name: "Avinash Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "indirect-taxes": {
//     hod: { name: "Avinash Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },

//   /* Logistics & Warehousing */
//   "logistics-and-warehousing": {
//     hod: { name: "Sunita Prajapati" },
//     clusterHead: { name: "D S Rajora" },
//   },

//   /* Legal & Corporate Affairs */
//   "corporate-affairs-company-law-corporate-governance": {
//     hod: { name: "Avinash Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "intellectual-property-rights": {
//     hod: { name: "Avinash Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "legal-affairs-regulatory-reforms": {
//     hod: { name: "Avinash Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },

//   /* Infrastructure */
//   "civil-aviation": {
//     hod: { name: "Kavita Sharma" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },
//   "highway-tunnel-infrastructure": {
//     hod: { name: "Kavita Sharma" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },
//   "railways-council": {
//     hod: { name: "Sunita Prajapati" },
//     clusterHead: { name: "D S Rajora" },
//   },

//   /* Sustainability & Environment */
//   "sustainability-environment": {
//     hod: { name: "Abhay Kumar Yadav" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },
//   water: {
//     hod: { name: "Abhay Kumar Yadav" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },

//   /* Tourism */
//   "travel-tourism-and-hospitality": {
//     hod: { name: "Ram Kumar Vijayan" },
//     clusterHead: { name: "Mr. Varun Aggarwal" },
//   },
//   "branding-marketing": {
//     hod: { name: "Ram Kumar Vijayan" },
//     clusterHead: { name: "Mr. Varun Aggarwal" },
//   },

//   /* Real Estate & Urban Development */
//   "real-estate-housing-and-urban-development": {
//     hod: { name: "Sunita Prajapati" },
//     clusterHead: { name: "D S Rajora" },
//   },
//   "public-procurement": {
//     hod: { name: "Sumita Sharma" },
//     clusterHead: { name: "D S Rajora" },
//   },
//   "sez-and-industrial-zones": {
//     hod: { name: "Sunita Prajapati" },
//     clusterHead: { name: "D S Rajora" },
//   },

//   /* Manufacturing */
//   "manufacturing-capital-goods": {
//     hod: { name: "Yashpal" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "textile-technical-textile": {
//     hod: { name: "Yashpal" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "toy-council": {
//     hod: { name: "Mr. Varun Aggarwal" },
//     clusterHead: { name: "Mr. Varun Aggarwal" },
//   },
//   "chemical-petrochemicals": {
//     hod: { name: "Jaidev Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "eodb-council": {
//     hod: { name: "Yatika Gupta" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "hr-ir-policies-and-reforms": {
//     hod: { name: "Avinash Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "defence-aerospace": {
//     hod: { name: "Sumita Sharma" },
//     clusterHead: { name: "D S Rajora" },
//   },

//   /* Mines & Minerals */
//   "mines-minerals": {
//     hod: { name: "Jaidev Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },
//   "iron-steel": {
//     hod: { name: "Jaidev Sharma" },
//     clusterHead: { name: "Mr. Basudev Mukherjee" },
//   },

//   /* International Affairs */
//   "exports-trade": {
//     hod: { name: "Ms. Deepti Pant" },
//     clusterHead: { name: "Ms. Deepti Pant" },
//   },
//   "business-through-diplomacy": {
//     hod: { name: "Ms. Deepti Pant" },
//     clusterHead: { name: "Ms. Deepti Pant" },
//   },
//   "africa-business-council": {
//     hod: { name: "Ms. Deepti Pant" },
//     clusterHead: { name: "Ms. Deepti Pant" },
//   },
//   bimstec: {
//     hod: { name: "Ms. Deepti Pant" },
//     clusterHead: { name: "Ms. Deepti Pant" },
//   },
//   eurasia: {
//     hod: { name: "Ms. Deepti Pant" },
//     clusterHead: { name: "Ms. Deepti Pant" },
//   },

//   /* Startups */
//   startup: {
//     hod: { name: "Manveen Chadha" },
//     clusterHead: { name: "Dr. Ambika Sharma" },
//   },
// };


// function normaliseName(name = "") {
//   return name
//     .replace(/^(mr|ms|mrs|dr|prof)\.?\s+/i, "")
//     .replace(/\s+/g, " ")
//     .trim()
//     .toLowerCase();
// }

// export function getSectorHOD(councilSlug = "") {
//   return SECTOR_HOD[councilSlug] || null;
// }

// function Portrait({ person, className = "", imgClass = "" }) {
//   const [broken, setBroken] = useState(false);

//   if (broken || !person?.photo) {
//     return (
//       <span
//         className={`flex items-center justify-center bg-gradient-to-br from-[#FEF7F4] to-[#FAF7F2] text-3xl font-bold text-[#DA2128] ${className}`}
//         aria-hidden="true"
//       >
//         {getInitials(person?.name || "")}
//       </span>
//     );
//   }

//   return (
//     <img
//       src={person.photo}
//       alt={person.name}
//       onError={() => setBroken(true)}
//       loading="lazy"
//       className={`${className} ${imgClass} object-cover object-top`}
//     />
//   );
// }

// function PersonCard({ person, role, councilName, delay = 0 }) {
//   // Keep icon selection explicit. Do not store React components in the data map:
//   // an unavailable icon export would otherwise become `undefined` at render time.
//   const RoleIcon = role.includes("Cluster") ? FaUsers : FaUser;

//   return (
//     <Reveal delay={delay} variant="zoom">
//       <article className="group relative flex h-full items-center gap-5 overflow-hidden rounded-3xl border border-stone-200 bg-white p-5 shadow-[0_2px_20px_-14px_rgba(28,25,23,.5)] transition-all duration-500 hover:-translate-y-1.5 hover:border-[#DA2128]/30 hover:shadow-2xl hover:shadow-[#DA2128]/12 sm:p-6">
//         <span className="pointer-events-none absolute -right-14 -top-14 h-36 w-36 rounded-full bg-gradient-to-br from-[#FEF7F4] to-[#FAF7F2] transition-transform duration-700 group-hover:scale-150" />
//         <FaLeaf
//           aria-hidden="true"
//           className="pointer-events-none absolute -bottom-4 right-2 h-24 w-24 text-[#DA2128]/5"
//         />

//         <div className="relative shrink-0">
//           <span className="absolute -inset-1 rounded-2xl bg-gradient-to-br from-[#DA2128] via-[#DB6400] to-[#F59C00] opacity-80" />
//           <Portrait
//             person={person}
//             className="relative h-[124px] w-[104px] rounded-2xl border-2 border-white sm:h-[150px] sm:w-[126px]"
//             imgClass="transition-transform duration-700 group-hover:scale-[1.04]"
//           />
//         </div>

//         <div className="relative min-w-0">
//           <span className="inline-flex items-center gap-1.5 rounded-full bg-[#DA2128] px-3 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-white">
//             <RoleIcon aria-hidden="true" className="h-3 w-3" />
//             {role}
//           </span>

//           <h3
//             style={SERIF}
//             className="mt-3 text-[22px] font-bold leading-tight text-stone-900 transition-colors group-hover:text-[#DA2128] sm:text-2xl"
//           >
//             {person.name}
//           </h3>

//           <p className="mt-1.5 text-[13.5px] font-semibold leading-snug text-stone-600">
//             ASSOCHAM Council Secretariat
//           </p>

//           {councilName && (
//             <p className="mt-1 line-clamp-2 text-[11.5px] font-medium leading-relaxed text-stone-400">
//               {councilName}
//             </p>
//           )}

//           <span className="mt-4 flex items-center gap-2" aria-hidden="true">
//             <span className="h-[3px] w-8 rounded-full bg-[#DA2128]" />
//             <span className="h-[3px] w-3 rounded-full bg-[#F59C00]" />
//           </span>
//         </div>
//       </article>
//     </Reveal>
//   );
// }

// export function SectorHOD({
//   councilSlug: councilSlugProp,
//   sector,
//   className = "",
// }) {
//   const { councilSlug: routeCouncilSlug } = useParams();
//   const councilSlug = councilSlugProp || routeCouncilSlug || "";
//   const data = getSectorHOD(councilSlug);

//   if (!data?.hod?.name) return null;

//   const councilName = sector?.title || "";
//   const samePerson =
//     data.clusterHead?.name &&
//     normaliseName(data.hod.name) === normaliseName(data.clusterHead.name);

//   const people = samePerson
//     ? [
//         {
//           person: data.hod,
//           role: "ASSOCHAM HoD & Cluster Head",
//         },
//       ]
//     : [
//         {
//           person: data.hod,
//           role: "ASSOCHAM HoD",
//         },
//         ...(data.clusterHead?.name
//           ? [
//               {
//                 person: data.clusterHead,
//                 role: "ASSOCHAM Cluster Head (ASG)",
//               },
//             ]
//           : []),
//       ];

//   return (
//     <section
//       id="hod"
//       className={`sector-section relative scroll-mt-6 overflow-hidden bg-gradient-to-b from-white via-[#FEF7F4] to-[#FAF7F2] py-20 lg:py-24 ${className}`}
//     >
//       <div className="pointer-events-none absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-white to-transparent" />
//       <div className="pointer-events-none absolute -right-28 top-16 h-72 w-72 rounded-full bg-[#F59C00]/10 blur-3xl" />
//       <div className="pointer-events-none absolute -left-28 bottom-0 h-72 w-72 rounded-full bg-[#DA2128]/10 blur-3xl" />

//       <div className="relative mx-auto max-w-7xl px-6">
//         <SectionHeading eyebrow="Council Secretariat" title="Head of Department" />

//         <div
//           className={`mx-auto mt-10 grid max-w-5xl gap-6 ${
//             people.length === 1 ? "max-w-2xl" : "md:grid-cols-2"
//           }`}
//         >
//           {people.map(({ person, role }, index) => (
//             <PersonCard
//               key={`${role}-${person.name}`}
//               person={person}
//               role={role}
//               councilName={councilName}
//               delay={index * 120}
//             />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// export default SectorHOD;




// new new code 







/*
 * Sector contact directory.
 * No React component / HoD cards are rendered from this file.
 */

export const DEFAULT_SECTOR_CONTACT = {
  email: "assocham@nic.in",
  phone: "011-46550555",
  address: [
    "4th Floor, YMCA Cultural Centre and Library Building,",
    "01, Jai Singh Road,",
    "New Delhi - 110001",
  ],
  addressUrl:
    "https://www.google.com/maps?ll=28.626824,77.213067&z=15&t=m&hl=en&gl=IN&mapclient=embed&cid=12074703925506796112",
};

const createEntries = (slugs, hod, clusterHead, email, phone) =>
  Object.fromEntries(
    slugs.map((slug) => [
      slug,
      {
        hod: { name: hod, email, phone },
        clusterHead: { name: clusterHead },
      },
    ])
  );

export const SECTOR_HOD = {
  ...createEntries(
    ["agri-industries-farming-practices", "food-processing-value-addition", "pharmaceuticals", "med-tech-devices", "healthcare-wellness"],
    "Tanuja Adhikari", "D S Rajora", "tanuja.adhikari@assocham.com", "9910044086"
  ),
  ...createEntries(
    ["auto-auto-ancillaries", "green-mobility", "public-procurement", "defence-aerospace"],
    "Sumita Sharma", "D S Rajora", "sumita.shama@assocham.com", "9873379795"
  ),
  ...createEntries(
    ["msme-development-council", "exports-trade", "business-through-diplomacy", "africa-business-council", "bimstec", "eurasia"],
    "Ms. Deepti Pant", "Ms. Deepti Pant", "deepti.pant@assocham.com", "9717838540"
  ),
  ...createEntries(
    ["electronics-components", "animation-visual-effects-gaming-comics-avgc", "cyber-security-cyber-law", "data-centre", "digital-communication", "it-ites-digital-commerce", "fintech", "toy-council"],
    "Mr. Varun Aggarwal", "Mr. Varun Aggarwal", "varun.aggarwal@assocham.com", "9910613815"
  ),
  ...createEntries(
    ["hydropower-psp", "power-generation", "power-distribution", "power-transmission", "renewable-energy", "civil-aviation", "highway-tunnel-infrastructure"],
    "Kavita Sharma", "Dr. Ambika Sharma", "kavita.sharma@assocham.com", "9871801002"
  ),
  ...createEntries(
    ["banking", "corporate-bond-market", "insurance", "nbfcs-green-financing", "stressed-assets"],
    "Ankit Raghav", "Mr. Basudev Mukherjee", "ankit.raghav@assocham.com", "9999068767"
  ),
  ...createEntries(
    ["capital-markets", "commodity-markets-investments"],
    "Ankit Krishna", "D S Rajora", "ankit.krishna@assocham.com", "7838567953"
  ),
  ...createEntries(
    ["cfos", "direct-taxes", "indirect-taxes", "corporate-affairs-company-law-corporate-governance", "intellectual-property-rights", "legal-affairs-regulatory-reforms", "hr-ir-policies-and-reforms"],
    "Avinash Sharma", "Mr. Basudev Mukherjee", "avinash.sharma@assocham.com", "8700449266 / 9811524976"
  ),
  ...createEntries(
    ["national-council-on-education"],
    "Swati Sharma", "Dr. Ambika Sharma", "swati.sharma@assocham.com", "98995 05495"
  ),
  ...createEntries(
    ["logistics-and-warehousing", "railways-council", "real-estate-housing-and-urban-development", "sez-and-industrial-zones"],
    "Sunita Prajapati", "D S Rajora", "sunita.prajapati@assocham.com", "99999 85318"
  ),
  ...createEntries(
    ["sustainability-environment", "water"],
    "Abhay Kumar Yadav", "Dr. Ambika Sharma", "abhay.yadav@assocham.com", "9990905508"
  ),
  ...createEntries(
    ["travel-tourism-and-hospitality", "branding-marketing"],
    "Ram Kumar Vijayan", "Mr. Varun Aggarwal", "ramkumar.vijayan@assocham.com", "9873 68 8093"
  ),
  ...createEntries(
    ["manufacturing-capital-goods", "textile-technical-textile"],
    "Yashpal", "Mr. Basudev Mukherjee", "yashpal@assocham.com", "7503531087"
  ),
  ...createEntries(
    ["chemical-petrochemicals", "mines-minerals", "iron-steel"],
    "Jaidev Sharma", "Mr. Basudev Mukherjee", "jaidev.sharma@assocham.com", "9990321148"
  ),
  ...createEntries(
    ["eodb-council"],
    "Yatika Gupta", "Mr. Basudev Mukherjee", "yatika.gupta@assocham.com", "9811523874"
  ),
  ...createEntries(
    ["startup"],
    "Manveen Chadha", "Dr. Ambika Sharma", "manveen.chadha@assocham.com", "97189 34343"
  ),
};

export function getSectorHOD(councilSlug = "") {
  return SECTOR_HOD[councilSlug] || null;
}

export function getSectorContact(councilSlug = "") {
  const assignment = getSectorHOD(councilSlug);

  return {
    hodName: assignment?.hod?.name || "ASSOCHAM Secretariat",
    clusterHeadName: assignment?.clusterHead?.name || "",
    email: assignment?.hod?.email || DEFAULT_SECTOR_CONTACT.email,
    phone: assignment?.hod?.phone || DEFAULT_SECTOR_CONTACT.phone,
    address: assignment?.hod?.address || DEFAULT_SECTOR_CONTACT.address,
    addressUrl: assignment?.hod?.addressUrl || DEFAULT_SECTOR_CONTACT.addressUrl,
  };
}
